import React from 'react';
import PropTypes from 'prop-types';
import GreenCheck from '../../themes/svg/greenCheck';
import config from '../../helpers/config';

const ShareEstimateMessage = ({ email, sharedDate }) => {
  if (email != null && sharedDate != null && config.repId() !== null) {
    return (
      <div className="estimateSummaryMessage">
        <GreenCheck />
        <span className="messageText desktop-only inline">
          Now auto-saving. Shared with <a href={`mailto:${email}`}>{email}</a>
        </span>
        <span
          className="messageText tablet-mobile-only inline"
          title={`Now auto-saving. Shared with ${email}`}
        >
          Shared
        </span>
      </div>
    );
  }
  return null;
};

ShareEstimateMessage.propTypes = {
  email: PropTypes.string,
  sharedDate: PropTypes.string,
};

ShareEstimateMessage.defaultProps = {
  email: null,
  sharedDate: null,
};

export default ShareEstimateMessage;
